const palette = {
  white: "#ffffff",
  red: "#FF0000",
  gray: "#b5b5b5",
  black: "#000000",
  grayLight: "#dbdbdb",
  grayLighter: "#F8F8F8",
  // grayLighter: "#dfdfdf",
  grayDark: "#333333",
  grayDarker: "#121212",
  whiteRGBA: (opacity) => `rgba(255, 255, 255, .${parseInt(opacity)})`,
  blackRGBA: (opacity) => `rgba(0, 0, 0, .${parseInt(opacity)})`,
  greenRGBA: (opacity) => `rgba(0, 255, 0, .${parseInt(opacity)})`,
  redRGBA: (opacity) => `rgba(255, 0, 0, .${parseInt(opacity)})`,
  yellowRGBA: (opacity) => `rgba(255, 255, 0, .${parseInt(opacity)})`,
  grayRGBA: (opacity) => `rgba(181, 181, 181, .${parseInt(opacity)})`,
  grayLightRGBA: (opacity) => `rgba(219, 219, 219, .${parseInt(opacity)})`,
};

export default palette;
